export const numberToChar = (number: number): string => {
  return String.fromCharCode(96 + number)
}

export const charToNumber = (char: string): number => {
  return char.toLowerCase().charCodeAt(0) - 96
}
